/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserAuthService} from "../../services/user-auth.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'gm-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.less'],
    standalone: false
})
export class SidebarComponent implements OnInit {
  @Input() sidebarOpen: boolean;
  @Output() closeSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();
  userLanguageSession = sessionStorage.getItem("userLanguageSetting");

  public isSuperAdmin: boolean = false;
  public isSiteAdmin: boolean = false;
  public object;

  @Input() user: any;

  constructor(private userAuthService: UserAuthService,private translateService: TranslateService) {
    if (this.userLanguageSession != undefined) {
      translateService.setDefaultLang(this.userLanguageSession);
    }
    else {
      let language = translateService.currentLang;
      if (language==undefined) language='en';
      if (language.indexOf('en')<0 && language.indexOf('pt')<0 && language.indexOf('ch')<0 && language.indexOf('ko')<0){
        sessionStorage.setItem("userLanguageSetting",'en');
      }
      else{
        if (language.indexOf('en')>=0)
          language='en';
        sessionStorage.setItem("userLanguageSetting",language);
      }
      translateService.setDefaultLang(language);
    }

  }

  ngOnInit(): void {
    this.getLocalUser();
  }

  getLocalUser(): void{
    if(sessionStorage.getItem("isSuperAdmin")!== null && sessionStorage.getItem("isSiteAdmin") !==null ) {
      this.isSuperAdmin = (sessionStorage.getItem("isSuperAdmin") === "true");
      this.isSiteAdmin = (sessionStorage.getItem("isSiteAdmin") === "true");
    }
    else {
      this.userAuthService.getUserAuth().subscribe(user => {
        let currUser = user;
        this.isSuperAdmin = currUser.isSuperAdmin;
        this.isSiteAdmin = currUser.isSiteAdmin;
      });
    }
  }

  emitCloseSidebar() {
    this.sidebarOpen = false;
    this.closeSidebar.emit();
    if(this.object)
      this.object.srcElement.nextElementSibling.setAttribute('class','collapse');
  }
  mouseoverAccident(obj){
    //console.log(obj.srcElement.nextElementSibling);
    obj.srcElement.nextElementSibling.setAttribute('class','collapse in');
    this.object= obj;
  }
  mouseoutAccident(obj){
    obj.srcElement.setAttribute('class','collapse');
    this.object= obj;
  }

}
